<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>未完整填写物流编号</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主内容容器 -->
    <div class="content-container">
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="店铺">
          <el-select v-model="formInline.shopIds" placeholder="请选择店铺" clearable multiple style="width: 80px;">
            <el-option v-for="shop in shopList" :key="shop.id" :label="shop.shopName" :value="shop.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.orderSn" placeholder="请输入订单号" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="平台">
          <dict-select v-model="formInline.erpPlatform" category-id="ERP_PLATFORM" placeholder="请选择平台" clearable style="width: 120px;"></dict-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="formInline.orderStates" placeholder="订单状态" clearable style="width: 120px;">
            <el-option v-for="item in orderStatusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table ref="table" :data="tableData" border style="width: 100%;" v-loading="loading" @expand-change="handleExpandChange" @sort-change="handleSortChange">
        <!-- 展开列 -->
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="order-items-section">
              <el-table :data="scope.row.orderItems" border style="width: 100%; ">
                <!-- <el-table-column type="index" label="序号" width="60" align="center"></el-table-column> -->
                <el-table-column label="商品图片" width="150" align="center">
                  <template slot-scope="item">
                    <img :src="item.row.itemImage || '/static/img/default-product.png'"
                      style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px;" @error="handleImageError" />
                  </template>
                </el-table-column>
                <el-table-column prop="itemName" label="商品名称" min-width="200" show-overflow-tooltip>
                  <template slot-scope="item">
                    <span class="item-name clickable-item-name"
                          @click="copyItemName(item.row.itemName)"
                          :title="'点击复制商品名称: ' + item.row.itemName">
                      {{ item.row.itemName }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="itemModelName" label="规格" min-width="150" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="amount" label="数量" width="90" align="center">
                </el-table-column>
                <el-table-column prop="itemPrice" label="单价" width="120" align="center">
                  <template slot-scope="item">
                    NT$ {{ item.row.itemPrice }}
                  </template>
                </el-table-column>
                <el-table-column prop="purchaseUserName" label="采购人" width="100" align="center">
                  <template slot-scope="item">
                    {{ item.row.purchaseUserName || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="expressNo" label="快递编号" min-width="150" align="center">
                  <template slot-scope="item">
                    <span v-if="item.row.expressNo"
                          class="express-no clickable-express"
                          @click="copyExpressNo(item.row.expressNo)"
                          :title="'点击复制快递号: ' + item.row.expressNo">
                      {{ item.row.expressNo }}
                    </span>
                    <span v-else class="no-express">未填写</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="shopName" label="店铺名称" width="130" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="orderSn" label="订单号" width="180" align="center">
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: bold; cursor: pointer;"
                  @click="copyOrderSn(scope.row.orderSn)"
                  :title="'点击复制订单号'">
              {{ scope.row.orderSn }}
            </span>
          </template>
        </el-table-column>
        <dict-table-column prop="erpPlatform" label="平台" category-id="ERP_PLATFORM" width="80" align="center">
        </dict-table-column>
        <dict-table-column prop="orderStates" label="订单状态" category-id="ERP_ORDER_STATUS" width="110" align="center">
        </dict-table-column>
        <el-table-column prop="createTime" label="下单时间" width="160" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="timePassed" label="未处理时长" width="150" align="center">
          <template slot-scope="scope">
            <span :class="getTimeDurationClass(scope.row.createTime)">
              {{ calculateTimeDuration(scope.row.createTime) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="剩余发货时间" width="180" align="center" prop="autoCancel3plAckDate" sortable="custom">
          <template slot-scope="scope">
            <span v-if="scope.row.autoCancel3plAckDate" :style="{ color: isCountdown(scope.row.autoCancel3plAckDate, scope.row.orderStates) ? 'chocolate' : '' }">
              {{ formatShipTime(scope.row.autoCancel3plAckDate, scope.row.orderStates) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalPrice" label="订单金额" width="140" align="center">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: bold;">NT$ {{ scope.row.totalPrice }}</span>
          </template>
        </el-table-column>
        <!-- 使用NoteColumn组件 -->
        <NoteColumn :current-scene="currentScene" />
        <el-table-column label="操作" min-width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="openNotesDrawer(scope.row)" icon="el-icon-tickets">备注</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="empty-table-placeholder">
            <i class="el-icon-warning-outline" style="font-size: 32px; color: #C0C4CC; margin-bottom: 10px;"></i>
            <p>暂无数据</p>
          </div>
        </template>
      </el-table>

      <!-- 分页 -->
      <Pagination v-bind:child-msg="pageParam" @callback_getPageData="callback_getPageData"></Pagination>
    </div>
    
    <!-- 使用EditNoteDialog组件 -->
    <EditNoteDialog
      :visible.sync="noteDialogVisible"
      :orderSn="currentOrderSn"
      :scene="currentScene"
      sceneName="未完整填写物流编号"
      @saved="handleNoteSaved" />

    <!-- 备注抽屉 -->
    <el-drawer
      title="订单备注"
      :visible.sync="notesDrawerVisible"
      direction="rtl"
      size="600px"
      :before-close="handleDrawerClose">
      <div style="padding: 20px;">
        <OrderNotesDrawer
          :notes="currentOrderNotes"
          :orderSn="currentOrderSn"
          :currentScene="currentScene"
          :showDebug="false"
          @note-updated="handleNoteUpdated" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { incompleteLogisticsPageWithItems, getOrderStates } from '../../api/ErpOrder'
import { getAllEnabledShops } from '../../api/SysShop'
import { getByOrderSnAndScene } from '../../api/WkbNote'
import Pagination from '../../components/Pagination'
import DictSelect from '../../components/DictSelect'
import DictTableColumn from '../../components/DictTableColumn'
import OrderNotesDrawer from './OrderNotesDrawer'
import EditNoteDialog from '../../components/EditNoteDialog'
import NoteColumn from '../../components/NoteColumn'
import copyMixin from '../../mixins/copyMixin'

export default {
  name: 'OrdLogisticsNotComplete',
  mixins: [copyMixin],
  components: {
    Pagination,
    DictSelect,
    DictTableColumn,
    OrderNotesDrawer,
    EditNoteDialog,
    NoteColumn
  },
  data() {
    return {
      // 搜索表单数据
      formInline: {
        current: 1,
        size: 10,
        shopIds: [],
        orderSn: '',
        erpPlatform: '',
        orderStates: '',
        orders: []
      },
      // 表格数据
      tableData: [],
      // 店铺列表
      shopList: [],
      // 订单状态列表
      orderStatusList: [],
      // 分页数据
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      // 备注弹窗
      noteDialogVisible: false,
      currentOrderSn: '',
      currentScene: '02',  // 默认场景为"未完整填写物流编号"
      currentOrder: null,

      // 备注抽屉
      notesDrawerVisible: false,
      currentOrderNotes: [],

      // 倒计时定时器
      countdownTimer: null,
      // 当前时间戳（用于倒计时更新）
      currentTimestamp: Math.floor(Date.now() / 1000)
    }
  },
  created() {
    // 检查URL参数中是否有orderSn
    if (this.$route.query.orderSn) {
      this.formInline.orderSn = this.$route.query.orderSn;
    }
    this.getPageData()
    this.loadShops()
    this.loadOrderStates()
  },
  mounted() {
    // 启动倒计时定时器，每秒更新当前时间戳
    this.countdownTimer = setInterval(() => {
      this.currentTimestamp = Math.floor(Date.now() / 1000);
    }, 1000);
  },
  beforeDestroy() {
    // 清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    // 获取分页数据
    getPageData(parameter) {
      this.loading = true
      if (!parameter) {
        parameter = {
          current: this.formInline.current,
          size: this.formInline.size,
          shopIds: this.formInline.shopIds && this.formInline.shopIds.length > 0 ? this.formInline.shopIds.map(id => String(id)) : undefined,
          orderSn: this.formInline.orderSn || undefined,
          erpPlatform: this.formInline.erpPlatform || undefined,
          orderStates: this.formInline.orderStates || undefined,
          orders: this.formInline.orders
        }
      }

      incompleteLogisticsPageWithItems(parameter)
        .then(res => {
          this.loading = false
          this.tableData = res.data.records
          this.pageParam.currentPage = res.data.current
          this.pageParam.pageSize = res.data.size
          this.pageParam.total = res.data.total
        })
    },
    
    // 打开编辑备注弹窗
    openEditNoteDialog(row) {
      this.currentOrder = row
      this.currentOrderSn = row.orderSn
      this.currentScene = '02'
      this.noteDialogVisible = true
    },

    // 打开备注抽屉
    openNotesDrawer(row) {
      this.currentOrder = row
      this.currentOrderSn = row.orderSn
      this.currentScene = '02'
      this.currentOrderNotes = row.notes || []
      this.notesDrawerVisible = true
    },

    // 关闭抽屉
    handleDrawerClose() {
      this.notesDrawerVisible = false
      this.currentOrderNotes = []
    },
    
    // 处理备注保存成功事件
    handleNoteSaved(noteData) {
      console.log('备注已保存:', noteData)

      // 如果有当前订单对象，更新其备注数据
      if (this.currentOrder) {
        // 查询该订单的指定场景的备注
        getByOrderSnAndScene({
          orderSn: this.currentOrder.orderSn,
          scene: '02'
        }).then(res => {
          if (res.success && res.data) {
            // 初始化notes数组（如果不存在）
            if (!this.currentOrder.notes) {
              this.currentOrder.notes = [];
            }

            // 查找是否已有相同场景的备注
            const existingNoteIndex = this.currentOrder.notes.findIndex(note => note.scene === '02');
            if (existingNoteIndex !== -1) {
              // 替换已有的备注
              this.currentOrder.notes[existingNoteIndex] = res.data;
            } else {
              // 添加新的备注
              this.currentOrder.notes.push(res.data);
            }

            // 强制刷新视图
            this.$forceUpdate();
          }
        });
      }

      // 刷新列表数据（可选，取决于业务需求）
      setTimeout(() => {
        this.getPageData()
      }, 500)
    },

    // 格式化日期时间（支持LocalDateTime字符串和Unix时间戳）
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      // 如果是字符串（LocalDateTime格式），直接返回
      if (typeof dateTime === 'string') {
        return dateTime;
      }
      // 如果是数字（Unix时间戳），转换为日期时间
      const date = new Date(dateTime * 1000);
      return date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0') + ' ' +
        String(date.getHours()).padStart(2, '0') + ':' +
        String(date.getMinutes()).padStart(2, '0') + ':' +
        String(date.getSeconds()).padStart(2, '0');
    },

    // 判断是否处于倒计时状态
    isCountdown(timestamp, orderStates) {
      if (!timestamp || orderStates !== '001') return false;
      const now = this.currentTimestamp;
      return timestamp > now;
    },

    // 格式化发货时间（支持倒计时）
    formatShipTime(timestamp, orderStates) {
      if (!timestamp) return '-';

      // 只有订单状态为"001"（待出货）时才显示倒计时
      if (orderStates !== '001') {
        return this.formatDateTime(timestamp);
      }

      const now = this.currentTimestamp;
      if (timestamp <= now) {
        // 已过期或倒计时为0，显示日期时间
        const date = new Date(timestamp * 1000);
        return date.getFullYear() + '-' +
          String(date.getMonth() + 1).padStart(2, '0') + '-' +
          String(date.getDate()).padStart(2, '0') + ' ' +
          String(date.getHours()).padStart(2, '0') + ':' +
          String(date.getMinutes()).padStart(2, '0') + ':' +
          String(date.getSeconds()).padStart(2, '0');
      } else {
        // 未过期，显示倒计时
        const diff = timestamp - now;
        const days = Math.floor(diff / 86400);
        const hours = Math.floor((diff % 86400) / 3600);
        const minutes = Math.floor((diff % 3600) / 60);
        const seconds = diff % 60;
        return `${days}天${hours}时${minutes}分${seconds}秒`;
      }
    },

    // 处理备注更新事件（从OrderNotes组件触发）
    handleNoteUpdated() {
      console.log('备注已更新，动态更新表格数据')

      // 不刷新整个页面，而是动态更新表格中的备注数据
      if (this.currentOrder && this.currentOrderSn) {
        // 延迟查询，确保后端数据已更新
        setTimeout(() => {
          // 查询该订单的所有备注（不限场景）
          getByOrderSnAndScene({
            orderSn: this.currentOrderSn,
            scene: '02'
          }).then(res => {
            // 在表格数据中找到当前订单
            const orderIndex = this.tableData.findIndex(order => order.orderSn === this.currentOrderSn)
            if (orderIndex !== -1) {
              // 初始化notes数组（如果不存在）
              if (!this.tableData[orderIndex].notes) {
                this.$set(this.tableData[orderIndex], 'notes', [])
              }

              // 获取当前用户ID
              const userEntity = this.$store.getters.userEntity || JSON.parse(localStorage.getItem('userEntity') || '{}')
              const currentUserId = userEntity.id || userEntity.userId

              if (res.success && res.data) {
                // 有备注数据，更新或添加
                // 查找是否已有相同场景的备注
                const existingNoteIndex = this.tableData[orderIndex].notes.findIndex(
                  note => note.scene === '02' && note.createUserId === currentUserId
                )

                if (existingNoteIndex !== -1) {
                  // 替换已有的备注
                  this.$set(this.tableData[orderIndex].notes, existingNoteIndex, res.data)
                } else {
                  // 添加新的备注
                  this.tableData[orderIndex].notes.push(res.data)
                }
              } else {
                // 没有备注数据，说明备注已被删除
                // 从notes数组中移除当前场景的当前用户的备注
                const filteredNotes = this.tableData[orderIndex].notes.filter(
                  note => !(note.scene === '02' && note.createUserId === currentUserId)
                )
                this.$set(this.tableData[orderIndex], 'notes', filteredNotes)
              }

              // 更新当前订单对象
              this.currentOrder = this.tableData[orderIndex]

              // 如果抽屉是打开状态，更新抽屉中的备注数据
              if (this.notesDrawerVisible) {
                this.currentOrderNotes = this.tableData[orderIndex].notes || []
              }

              console.log('备注已动态更新到表格')
            }
          }).catch(err => {
            console.error('查询备注失败:', err)
          })
        }, 200) // 延迟200ms确保后端数据已更新
      }
    },
    
    // 获取特定场景的备注
    getSceneNotes(notes, scene) {
      if (!notes || !Array.isArray(notes)) return []
      return notes.filter(note => note.scene === scene)
    },


    
    // 加载店铺数据
    loadShops() {
      getAllEnabledShops()
        .then(res => {
          if (res.success && res.data && res.data.records) {
            this.shopList = res.data.records
          }
        })
        .catch(err => {
          console.error('加载店铺数据失败：', err)
        })
    },

    // 加载订单状态数据
    loadOrderStates() {
      getOrderStates()
        .then(res => {
          if (res.success && res.data) {
            this.orderStatusList = res.data
          }
        })
        .catch(err => {
          console.error('加载订单状态数据失败：', err)
        })
    },

    // 分页回调
    callback_getPageData(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getPageData()
    },

    // 搜索
    onSearch() {
      this.formInline.current = 1
      this.getPageData()
    },

    // 重置
    onReset() {
      this.formInline = {
        current: 1,
        size: 10,
        shopIds: [],
        orderSn: '',
        erpPlatform: '',
        orderStates: '',
        orders: []
      }
      this.getPageData()
    },

    // 排序处理
    handleSortChange(column) {
      if (column.order != null) {
        // 直接使用别名，不转换
        let orderBy = { column: column.prop, asc: column.order == 'ascending' }
        this.formInline.orders[0] = orderBy
      } else {
        this.formInline.orders = []
      }
      this.getPageData()
    },

    // 表格展开变化事件
    handleExpandChange(row, expandedRows) {
      console.log('展开行变化：', row, expandedRows)
    },

    // 切换行展开状态
    toggleRowExpansion(row) {
      this.$refs.table ? this.$refs.table.toggleRowExpansion(row) : null
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString('zh-CN')
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      const statusMap = {
        'WAIT_BUYER_CONFIRM_GOODS': 'warning',
        'WAIT_SELLER_SEND_GOODS': 'info',
        'TRADE_BUYER_SIGNED': 'success',
        'TRADE_CLOSED': 'danger'
      }
      return statusMap[status] || 'info'
    },

    // 处理图片加载错误
    handleImageError(event) {
      event.target.onerror = null
      event.target.src = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCI+PHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjZjBmMGYwIi8+PHRleHQgeD0iMzAiIHk9IjI2IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5Ij5Ob3Q8L3RleHQ+PHRleHQgeD0iMzAiIHk9IjQyIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5Ij5Gb3VuZDwvdGV4dD48L3N2Zz4="
    },

    // 计算未处理时长
    calculateTimeDuration(createTime) {
      if (!createTime) return ''

      const now = new Date()
      const orderTime = new Date(createTime)
      const diffInMs = now - orderTime

      // 转换为小时
      const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60))

      if (diffInHours < 24) {
        return `${diffInHours}小时`
      } else {
        const days = Math.floor(diffInHours / 24)
        const remainingHours = diffInHours % 24
        return remainingHours > 0 ? `${days}天${remainingHours}小时` : `${days}天`
      }
    },

    // 获取时长样式类
    getTimeDurationClass(createTime) {
      if (!createTime) return ''

      const now = new Date()
      const orderTime = new Date(createTime)
      const diffInMs = now - orderTime
      const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60))

      if (diffInHours >= 72) return 'duration-critical'  // 72小时以上：紧急
      if (diffInHours >= 48) return 'duration-warning'   // 48-72小时：警告
      if (diffInHours >= 24) return 'duration-attention' // 24-48小时：注意
      return 'duration-normal'                           // 24小时内：正常
    }
  }
}
</script>

<style scoped>
.content-container {
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 24px;
  margin-top: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

.empty-table-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #909399;
  text-align: center;
}

/* 订单项展开区域样式 */
.order-items-section {
  background-color: #f8f9fa;
  /* padding: 15px; */
  border-radius: 6px;
  /* margin: 10px; */
}

.order-items-section h4 {
  color: #409EFF;
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 2px solid #409EFF;
  padding-bottom: 8px;
}

.price {
  color: #E6A23C;
  font-weight: bold;
}

.express-no {
  color: #67C23A;
  font-weight: bold;
  background-color: #F0F9FF;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #67C23A;
}

.no-express {
  color: #909399;
  font-style: italic;
}

.clickable-express {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-express:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

/* 未处理时长样式 */
.duration-normal {
  color: #67C23A;
  font-weight: bold;
}

.duration-attention {
  color: #E6A23C;
  font-weight: bold;
}

.duration-warning {
  color: #F56C6C;
  font-weight: bold;
}

.duration-critical {
  color: #F56C6C;
  font-weight: bold;
  background-color: #FEF0F0;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #F56C6C;
}

/* 编辑备注弹窗样式 */
.note-dialog-content {
  padding: 20px;
}

.scene-code {
  color: #909399;
  font-size: 12px;
  margin-left: 8px;
}

/* 商品名称复制样式 */
.clickable-item-name {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-item-name:hover {
  opacity: 0.8;
  transform: scale(1.02);
}


</style>



// WEBPACK FOOTER //
// src/views/order/OrdLogisticsNotComplete.vue